import { render, staticRenderFns } from "./CreateProjectStatus.vue?vue&type=template&id=1b6bdc71"
import script from "./CreateProjectStatus.vue?vue&type=script&lang=js"
export * from "./CreateProjectStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports